import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("cc_cart")) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("cc_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (line, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.variant_id === line.variant_id);
      if (existing) {
        return prev.map((i) =>
          i.variant_id === line.variant_id ? { ...i, qty: i.qty + qty } : i
        );
      }
      return [...prev, { ...line, qty }];
    });
  };

  const updateQty = (variantId, qty) => {
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => i.variant_id !== variantId)
        : prev.map((i) => (i.variant_id === variantId ? { ...i, qty } : i))
    );
  };

  const removeItem = (variantId) =>
    setItems((prev) => prev.filter((i) => i.variant_id !== variantId));

  const clearCart = () => setItems([]);

  const { count, total } = useMemo(
    () => ({
      count: items.reduce((s, i) => s + i.qty, 0),
      total: items.reduce((s, i) => s + i.qty * i.unit_price, 0),
    }),
    [items]
  );

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clearCart, count, total }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
